import React, { useState } from "react";
import { useSetting } from "../../context/SettingContext";
// import { showNumSix } from "../../constants/constants";
import { translateColor, translateGender } from "../../utils";

// import JS files

const RingsSizeShow = (props) => {
  let windowWidth = window.screen.width;
      const { showNumSix } = useSetting();
  return (
    <>
      <div>
        <div className="flex items-center justify-between">
          <span className="show-label">
            کد: <span className="show-value"> {props.code}</span>
          </span>
          {props.dontShowNamdAndBrand ? (
            ""
          ) : (
            <>
              <span className="show-label">
                اسم: <span className="show-value"> {props.show_name}</span>
              </span>
              <span className="show-label">
                برند: <span className="show-value	"> {props.brand}</span>
              </span>
            </>
          )}

          <span className="show-label">
            جنسیت:{" "}
            <span className="show-value"> {translateGender(props.gender)}</span>
          </span>
          <span className="show-label">
            رنگ:{" "}
            <span className="show-value"> {translateColor(props.color)}</span>
          </span>
        </div>
        <div className="border rounded-md mt-4 overflow-hidden">
          <div className="flex justify-between">
            <div className="basis-1/2  text-center py-1 ">
              <span className="text-sm text-myblue-100">سایز</span>
            </div>
            <div className=" basis-1/2 text-center py-1 border-r ">
              <span className="text-sm text-myblue-100">وزن</span>
            </div>
          </div>
          <div className="flex justify-between">
            <div className="basis-1/2 border-t  text-center py-1">
              <span className="text-sm text-gray-700">1</span>
            </div>
            <div className=" basis-1/2 border-t text-center py-1 border-r">
              <span className="text-sm text-gray-700">
                {props.w1 !== "" ? props.w1 : "-"} گرم
              </span>
            </div>
          </div>
          <div className="flex justify-between">
            <div className="basis-1/2 border-t  text-center py-1">
              <span className="text-sm text-gray-700">2</span>
            </div>
            <div className=" basis-1/2 border-t text-center py-1 border-r">
              <span className="text-sm text-gray-700">
                {props.w2 !== "" ? props.w2 : "-"} گرم
              </span>
            </div>
          </div>
          <div className="flex justify-between">
            <div className="basis-1/2 border-t  text-center py-1">
              <span className="text-sm text-gray-700">3</span>
            </div>
            <div className=" basis-1/2 border-t text-center py-1 border-r">
              <span className="text-sm text-gray-700">
                {props.w3 !== "" ? props.w3 : "-"} گرم
              </span>
            </div>
          </div>
          <div className="flex justify-between">
            <div className="basis-1/2 border-t  text-center py-1">
              <span className="text-sm text-gray-700">4</span>
            </div>
            <div className=" basis-1/2 border-t text-center py-1 border-r">
              <span className="text-sm text-gray-700">
                {props.w4 !== "" ? props.w4 : "-"} گرم
              </span>
            </div>
          </div>
          <div className="flex justify-between">
            <div className="basis-1/2 border-t  text-center py-1">
              <span className="text-sm text-gray-700">5</span>
            </div>
            <div className=" basis-1/2 border-t text-center py-1 border-r">
              <span className="text-sm text-gray-700">
                {props.w5 !== "" ? props.w5 : "-"} گرم
              </span>
            </div>
          </div>
          {showNumSix ? <div className="flex justify-between">
            <div className="basis-1/2 border-t  text-center py-1">
              <span className="text-sm text-gray-700">6</span>
            </div>
            <div className=" basis-1/2 border-t text-center py-1 border-r">
              <span className="text-sm text-gray-700">
                {props.w6 !== "" ? props.w6 : "-"} گرم
              </span>
            </div>
          </div> : "" }
         
        </div>
      </div>
    </>
  );
};

export default RingsSizeShow;
